/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs */



/**
* | output |
* | --- |
* | "Position Bottom Right" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_bottom_right = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner en bas a droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position unten rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione in basso a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расположение: Нижний правый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición inferior derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置右下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右下の位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे दाईं ओर स्थित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição inferior direita")
	return /** @type {LocalizedString} */ ("Position Bottom Right")
});